import {
  apiRequest,
  recap360Detail,
  cancelToken
} from '../../../../../services/adapters/master/penialian360Service';

class DetailRepository {
  fetchDetail = async (query, token) => {
    return await apiRequest('get', recap360Detail, {
      cancelToken: token,
      params: query
    }, true);
  };

  cancelToken = () => {
    return cancelToken();
  };
}

export default DetailRepository;
